import { TableCell, TableRow } from '@mui/material';
import { generatePath } from 'react-router';

import { CustomerItemDto } from '@/api/generated';
import { TableRowLink } from '@/components/table/components/TableRowLink.comp.tsx';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useAppNavigation } from '@/utils/useAppNavigation.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { CustomerStatusChip } from '@/views/customers/status/CustomerStatusChip.comp.tsx';

type Props = {
  onCustomAction?: ((row: CustomerItemDto) => Promise<void> | void) | undefined;
  row: CustomerItemDto;
};

export const CustomersTableRow = ({ onCustomAction, row }: Props) => {
  const { t } = useTranslationWithPrefix('views.customers.table.body');
  const { push } = useAppNavigation();

  const detailsUrl = generatePath(RouteEnum.CUSTOMERS_DETAILS, {
    customerId: row.customerId.toString(),
  });
  const name = (
    <>
      {row.name} {row.distinguishingLabel && `(${row.distinguishingLabel})`}
    </>
  );

  const handleGoToCustomer = async () => {
    if (onCustomAction) {
      await onCustomAction(row);
      return;
    }
    push(detailsUrl);
  };

  return (
    <TableRow hover onClick={handleGoToCustomer} sx={{ cursor: 'pointer' }}>
      <TableCell>
        {onCustomAction ? name : <TableRowLink to={detailsUrl}>{name}</TableRowLink>}
      </TableCell>
      <TableCell>{row.nip}</TableCell>
      <TableCell>{row.address}</TableCell>
      <TableCell>{t(`typeOption.${row.type}`)}</TableCell>
      <TableCell>{t(`flagOption.${row.flag}`)}</TableCell>
      <TableCell>
        <CustomerStatusChip status={row.status} />
      </TableCell>
    </TableRow>
  );
};
